import React from 'react'
import styled from '../../../config/theme'

export default function CardInfo ({ label, content, icon }: CardInfoProps) {
  return (
    <Container>
      <Info>
        <Content>{content}</Content>
        <Label>{label}</Label>
      </Info>
      {icon}
    </Container>
  )
}

export interface CardInfoProps {
  label: string
  content: string
  icon: React.ReactNode
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 3px 9px 0 rgba(169,184,200,.15);

  &:not(:last-child) {
    border-right: 1px solid ${props => props.theme.color.lightGray};
  }
`

const Info = styled.div`

`

const Content = styled.div`
  color: #1c2d41;
  font-weight: bold;
  font-size: 1.875rem;
`

const Label = styled.div`
  color: #9eabc0;
  font-size: .875rem;
  margin-top: 5px;
`
